const urls = {
	socketEndpoint: process.env.REACT_APP_SOCKET_URL,
	backendURL: process.env.REACT_APP_BACKEND_URL
}

export default urls;